import React, { ReactElement } from 'react';
import { FastField as FormikField, FieldProps } from 'formik';
import { SingleSelectGroup, RadioButton } from '@xo-union/tk-component-switches';
import { compose } from '@xo-union/react-css-modules';
import { emptyQuestion } from '../../../../helpers/question';
import { Values } from '../../../../EventTypes';
import styles from './styles.scss';

interface AnswerTypeButtonsProps {
  values: Values;
}

const AnswerTypeButtons: React.FC<AnswerTypeButtonsProps> = ({ values }) => (
  <FormikField name="answerType">
    {({ field, form }: FieldProps): ReactElement => (
      <SingleSelectGroup>
        <div className={styles.radioButtonsContainer}>
          <div className={styles.radioButton}>
            <RadioButton
              checked={field.value === 'Text'}
              classes={compose({ container: styles.radioToggleSwitch })}
              onChange={(): any => form.setFieldValue('answerType', 'Text')}
              data-testid="textRadioRutton"
            >
              Short Answer
            </RadioButton>
          </div>
          <div className={styles.radioButton}>
            <RadioButton
              checked={field.value === 'Option'}
              classes={compose({ container: styles.radioToggleSwitch })}
              onChange={(): any => {
                form.setFieldValue('answerType', 'Option');

                if (!values.options || values.options.length === 0) {
                  form.setFieldValue('options', emptyQuestion.options);
                }
              }}
              data-testid="optionRadioRutton"
            >
              Multiple Choice
            </RadioButton>
          </div>
        </div>
      </SingleSelectGroup>
    )}
  </FormikField>
);

export default AnswerTypeButtons;
